<template>
<div class="" style="padding:70px 0;">



</div>
</template>

<script>
/*
ACCESSO A SELLA SIP

codice: XX9015076
PIN: 20181023

LINK AL BACKOFFICE DI TEST, per accedere usare i codici di accesso SIP
https://testecomm.sella.it/gestpay/Login.asp


4775718800002026	05/27	Always authorize with every amount
4775718800003024	05/27	Always reject: Authorization denied

Esempio di ritorno
https://www.sip.it/tesoreria/sella-back?a=GESPAY71800&b=RVRh6YbdL6T4VsGfKwc9hmzk0MAgScY7C6Mvg03h7B9m97Wij8LnNMgIyY4ndLXaSwdR3Ae16K32M5mZ2IKTNJ%2a2llMYGTlZCYiJw93b7ANDjNe49wM37RAQ_jyeXEaHbJrKaioyGzP1vAfaVpJrttCOqLX6WX8S8g8D0J%2a%2anQLlkgzbTTCusk19FoWj6sA_Flqgr4zEKrzJIrmTHhwT7hR8jTxWluh4wa44zf7ERmVCNLEWBR6Wj43BjVLAsNKExnr6xIUHMJLBYwgh9VEqtDDYMxE_HDHvLV8HVcVzKEO8ZW3GQvqHNO4DGZP6BgsuIX2FY%2amxERVCriWtwtnh24ih2O4m80FkZ4JbioJ3Erw6gOnbi16c26wfDS7NwIwKLSwbRzoxo9rSavIyxUio5q2y6lwmIP8FagDKYb2J7TOYU5A%2alV5O8urQR2GeJg%2aCuNsl9QrS%2as_GEmqkkQdITJYA2AQOFaeLGmM6pebp3XXKNpwoDuMHmPv0cYNBw1FyJ_X%2a1jraRNnnAFOHHkJlVh3BfHZ2W9vSCdQ8U2xwF7v%2atUCHo9OIYqx5G1al0_6b2oP9WyFQb7fgjlCLgLAN5C48qyhXVlHv6DRnK2_w1YYjt5k11PX9u589Yun23klrWPjCSswIA0oVta9XPFMymg



*/
import emailSellaTransaction from './Email-sella-transaction.vue'
import dbItem from '../teras/dbItem'
export default {
   name: 'home'
   ,components: {
   }
   ,data () {
      return {
         url:''
         ,a: ''
         ,b:''
         ,shopLogin:'9015076' 
         ,urlWS: "https://ecomms2s.sella.it/gestpay/gestpayws/WSCryptDecrypt.asmx?WSDL" //PRODUZIONE
         ,sella:{}
         ,online:{}
         ,versamento:{}
         
         
   
      }
   }
   ,created () {
      /* AMBIENTE DI TEST */
      this.shopLogin = 'GESPAY71800' 
      this.urlWS = "https://testecomm.sella.it/gestpay/gestpayws/WSCryptDecrypt.asmx?WSDL"

      this.url = new URL(window.location.href)
      this.a = this.url.searchParams.get("a")
      this.b = this.url.searchParams.get("b")


      var args = {
         shopLogin: this.shopLogin
         ,CryptedString: this.b
      }
      this.$axios.post(this.$axios.apiUrl+'vue/sella',{url:this.urlWS,action:'Decrypt',args: args}).then(async (response) => {
         this.sella = response.data.data.result

         if(this.sella.TransactionResult=="OK"){
            this.online = new dbItem({table:'online'})
            await this.online.load(this.sella.ShopTransactionID)
            if(this.online.row.stato==0){
               this.online.row.stato=1
               this.online.row.browsersella = this.$teras.browser.name +' '+ this.$teras.browser.version +' '+ this.$teras.browser.os
               this.online.row.more = JSON.stringify(this.sella)
               
            }

            if(this.online.row.stato==1){
               //Procedo alla gestione del versamento
               this.versamento = new dbItem({table:'versamento'})
               await this.versamento.new()
               this.versamento.row.contatto = this.online.row.contatto
               this.versamento.row.mezzo = 105
               this.versamento.row.sezione = 1
               this.versamento.row.fee = 2
               this.versamento.row.importo = this.online.row.importo
               this.versamento.row.utente = 1
               this.versamento.row.eseguitoil=this.$moment().format('YYYY-MM-DD')
               this.versamento.row.incassatoil=this.$moment().format('YYYY-MM-DD')
               this.versamento.row.modificatoil=this.$moment().format('YYYY-MM-DD HH:mm:ss')
               await this.versamento.save()
               await this.online.save()
               this.online.row.stato=2
            }

            if(this.online.row.stato==2){
               //Procedo con la gestione della banca
               var quote = JSON.parse(this.online.row.quote)
               var rows=[]
               var isNew = true
               for (let quota of quote){
                  isNew = true
                  for (let row of rows){
                     if(row.societa==quota.id){
                        row.importo +=quota.importo
                        isNew = false
                     }
                  }
                  if(isNew)
                     rows.push({id:'',contatto:this.versamento.row.contatto,versamento:this.versamento.row.id,importo:quota.importo,societa:quota.id})

               }

               await this.$axios.insertRows(rows,'banca')
               await this.online.save()
               this.online.row.stato=3

            }

            if(this.online.row.stato==2){
               // GESTIONE RICEVUTA   

               this.online.row.stato=9 
               await this.online.save()  
            }

            
         
         }else{
            //Dovrei inviare una email che la procedura non ha funzionato
/*
            console.log(this.url)
            console.log(this.a)
            console.log(this.b)
            console.log(this.$route.params)

*/
            var html = this.$teras.renderVue(emailSellaTransaction,{a:this.a,b:this.b,sella:JSON.stringify(this.sella)})
            this.$axios.email({from:'simgeped@terasmm.it',oggetto:'Errore con Sella',to:'mirko@terasmm.it',body:html}).then((data) => {
              console.log("Email inviata")
            }).catch((error) => {
              console.log("Errore nell'invio della email con gli errori ")
              console.log(error)
            })

         }



      }) 

   }

   
}
</script>

